import React, { useState, useEffect } from "react"
import { Route, Switch } from "react-router-dom"
import Loadable from "@bappweb/loadable"
import Header from "@smpu-web/globalmodules/header"
import Footer from "@smpu-web/globalmodules/footer"
import Landing from "./landing/main"
import Block from "@bappweb/block"
import StickyHeader from "./landing/main/stickyheader"
import { useAppDispatch, useAppSelector } from "../config/hook"
import { BAPPgetElementById } from "@bappweb/utils"
import { setSessionData } from "../state/sessionData"
import { useGetConfigListMutation } from "../api/services"
import { getQueryStringWithParam } from "../utils/utils"

const getQueryString = (param: string) => {
  let search = window.location.search.replace(/&amp;/g, '&');
  let params = new URLSearchParams(search);

  for (const [key, value] of params.entries()) {
    if (key.toLocaleLowerCase() === param.toLocaleLowerCase()) {
      return value;
    }
  }

  return null
}

const Main = () => {
  const dispatch = useAppDispatch()
  const [channel, setChannel] = useState<string | null | undefined>(getQueryString("channel"))
  const [cid, setCid] = useState<string | null | undefined>(getQueryString("cid"))
  const [isLanding, setIsLanding] = useState(BAPPgetElementById("form1"));

  const isDetails = useAppSelector((state) => state.isDetails.response?.isDetails)

  const [getConfigList] = useGetConfigListMutation();

  useEffect(() => {
    dispatch(
      setSessionData({
        channel: channel,
        cid: cid,
      })
    )

    getConfigList({
          functionCode: "CRC0003",
          cid: getQueryStringWithParam("firm") ?? "",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
          NextTransactionUrl: "Facebook/SMPUConfig/GetConfigListWithFunctionCode1"
        })
          .unwrap()
          .then((payload) => {
            if (!payload.IsError) {
              dispatch(
                setSessionData({
                  configList: payload.configList
                })
              )
            }
          })
  }, [])

  const routes = React.useMemo(
    () => ({
      Landing,
      Details: () => <Loadable loader={() => import("./details")} />,
      Result: () => <Loadable loader={() => import("./result")} />,
      NotFound: () => <Loadable loader={() => import("./not-found-404")} />
    }),
    []
  )
  const [scrollPosition, setScrollPositon] = React.useState(false)
  React.useEffect(() => {
    window.addEventListener('scroll', () => {
      setIsLanding(BAPPgetElementById("form1"))
      if (isLanding) {
        if (document.documentElement.scrollTop > 400) {
          setScrollPositon(true)
          dispatch(
            setSessionData({
              isStickyActive: true
            })
          )
        } else {
          setScrollPositon(false)
          dispatch(
            setSessionData({
              isStickyActive: false
            })
          )
        }
      } else {
        setScrollPositon(false)
        dispatch(
          setSessionData({
            isStickyActive: false
          })
        )
      }
    })
  }, [document.documentElement.scrollTop])

  return (
    <>
      <Block type="main" className="bapp-main">
        {scrollPosition && <StickyHeader />}
        {isDetails && <Header />}
        <Switch>
          <Route exact path="/" component={routes.Landing} />
          <Route path="/details/*" component={routes.Details} />
          <Route path="/result/*" component={routes.Result} />
          <Route component={routes.NotFound} />
        </Switch>
        <Footer />
      </Block>
    </>
  )
}

export default Main
